module.exports = __webpack_public_path__ + "img/warning.c5fc778f.svg";